import { useQuery } from '@tanstack/react-query';
import { fetchIncidents, type Incident } from '@/services/map/layers/incidentsLayer';

/**
 * React Query hook for fetching incidents
 * Fetches incidents globally when authenticated (polygon is optional context)
 */
export const usePolygonIncidents = (getToken: (() => Promise<string>) | undefined, polygonWkt: string | null) => {
  return useQuery<Incident[], Error>({
    queryKey: ['incidents', { polygonWkt }],
    // Fetch incidents when authenticated (polygon is optional for filtering)
    enabled: !!getToken,
    queryFn: async () => {
      if (!getToken) {
        throw new Error('getToken is required to fetch incidents');
      }
      return fetchIncidents(getToken);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
